export function formatNum(num, separator) {
    let str = Number.parseFloat(`${num}`).toLocaleString('en-US');
    str = str.replace(/,/g, separator);
    return str;
}
